import { BaseElement, defineElement } from '@webtides/element-js';
import GlideElementEvents from '../../elements/glide-element/GlideElementEvents';

class StageComponent extends BaseElement {
    properties() {
        return {
            addIntroTransition: false,
            animation: 'animate__rotateIn',
        };
    }

    events() {
        return {
            'glide-element': {
                [GlideElementEvents.GLIDE_RUN]: ev => {
                    this.initializeGlideListener();
                },
            },
        };
    }

    performAnimation() {
        setTimeout(() => {
            const $contentBoxes = this.querySelectorAll('.content-box-mobile');
            $contentBoxes.forEach($contentBox => {
                $contentBox.classList.remove('animate__animated');
                $contentBox.classList.remove(this.animation);
            });

            const $activeContentBox = this._glide
                ? this.querySelector('.glide__slide--active .content-box-mobile')
                : this.querySelector('.content-box-mobile');

            $activeContentBox.classList.add('animate__animated');
            $activeContentBox.classList.add(this.animation);
        }, 1000);
    }

    connected() {
        requestAnimationFrame(() => {
            this.initializeGlideListener();
            this.performAnimation();
        });
    }

    initializeGlideListener() {
        if (this._glide) {
            return;
        }

        this._glide = this.querySelector('glide-element')?._glide;
        if (!this._glide) {
            return;
        }
        this._glide.on('run.after', () => {
            this.performAnimation();
        });
    }
}

defineElement('stage-component', StageComponent);
